import { Alert, Button, Col, Form, Row } from "antd";

import { FormItemInput, FormItemSelect } from "../../ant-wrapper/form-item";
import { TIPO_VEICULOS_FIELDS } from "../../utils";
import { placaMask } from "../../../utils";

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

export default function VeiculosForm({
  onFinish,
  setError,
  error,
  initialValues = {},
  loading = false,
  viewMode = false,
}) {
  const [form] = Form.useForm();
  const onEdit = () => {
    setError();
  };
  const handlePlaca = (value) => {
    value = value.target.value;
    const fields = form.getFieldsValue();
    form.setFieldsValue({
      ...fields,
      placa: placaMask(value),
    });
  };
  return (
    <>
      {error && (
        <>
          <Alert message={error} type="error" />
          <br />
        </>
      )}
      <Form
        form={form}
        onChange={onEdit}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
        initialValues={initialValues}
      >
        <Row gutter={[8, 8]}>
          <Col span={4}>
            <FormItemSelect
              viewMode={viewMode}
              label="Tipo"
              name="tipo"
              items={TIPO_VEICULOS_FIELDS}
              required
              {...formItemLayout}
            />
          </Col>
        </Row>
        <Row gutter={[8, 8]}>
          <Col span={8}>
            <FormItemInput
              {...formItemLayout}
              name="descricao"
              rules={[
                { required: true, message: "Campo não pode ser vazio" },
                { max: 150, message: "Tamanho máximo de 150 caracteres" },
              ]}
              label="Descrição"
              viewMode={viewMode}
            />
          </Col>
          <Col span={8}>
            <FormItemInput
              {...formItemLayout}
              name="placa"
              rules={[{ max: 8, message: "Tamanho máximo de 7 caracteres" }]}
              label="Placa"
              viewMode={viewMode}
              onChangeInput={handlePlaca}
            />
          </Col>
        </Row>
        {!viewMode && (
          <Form.Item>
            <Button loading={loading} type="primary" htmlType="submit">
              Enviar
            </Button>
          </Form.Item>
        )}
      </Form>
    </>
  );
}
